import Plyr from 'plyr'
import { EvolokBannerManager } from '../util/EvolokActions'

const REWIND_ICON = '<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5 8.99867C19.5002 11.3648 18.5686 13.6359 16.9069 15.3202C15.2451 17.0046 12.9869 17.9669 10.6209 17.9987H10.5C8.20149 18.0044 5.98903 17.1248 4.32189 15.5424C4.2503 15.4747 4.19274 15.3936 4.15251 15.3036C4.11229 15.2136 4.09017 15.1166 4.08743 15.0181C4.08468 14.9196 4.10137 14.8216 4.13653 14.7295C4.17169 14.6375 4.22464 14.5532 4.29236 14.4816C4.36007 14.41 4.44122 14.3525 4.53117 14.3123C4.62113 14.272 4.71813 14.2499 4.81663 14.2472C4.91513 14.2444 5.01321 14.2611 5.10527 14.2963C5.19732 14.3314 5.28155 14.3844 5.35314 14.4521C6.42545 15.4634 7.77197 16.1363 9.22448 16.3867C10.677 16.6372 12.1711 16.4541 13.5202 15.8603C14.8692 15.2666 16.0134 14.2884 16.8098 13.0482C17.6062 11.8079 18.0195 10.3605 17.9981 8.88668C17.9766 7.41289 17.5214 5.97808 16.6893 4.76151C15.8571 3.54494 14.6849 2.60053 13.3192 2.04626C11.9534 1.492 10.4546 1.35245 9.00999 1.64506C7.56538 1.93766 6.23901 2.64944 5.19658 3.69148C5.18892 3.69976 5.18078 3.70759 5.1722 3.71492L4.18408 4.61961L5.77782 6.21336C5.88428 6.31782 5.95718 6.45166 5.98719 6.59776C6.0172 6.74387 6.00297 6.8956 5.94631 7.03357C5.88965 7.17155 5.79314 7.28949 5.66911 7.37234C5.54508 7.45519 5.39917 7.49917 5.25001 7.49867H0.750013C0.5511 7.49867 0.360335 7.41965 0.219683 7.279C0.0790302 7.13835 1.2636e-05 6.94758 1.2636e-05 6.74867V2.24867C-0.000850601 2.09993 0.0425336 1.95429 0.12465 1.83027C0.206767 1.70624 0.323907 1.60944 0.461179 1.55216C0.598451 1.49488 0.749655 1.47971 0.89557 1.50858C1.04149 1.53745 1.17552 1.60906 1.28064 1.71429L3.12283 3.56117L4.14845 2.62367C5.40843 1.36858 7.01201 0.51492 8.75676 0.170448C10.5015 -0.174024 12.3092 0.00613689 13.9516 0.688188C15.5941 1.37024 16.9976 2.5236 17.9851 4.00268C18.9726 5.48176 19.5 7.22024 19.5 8.99867Z" fill="#ADADA7"/></svg>'
const PAUSE_ICON = '<svg class="icon--pressed" aria-hidden="true" focusable="false" viewBox="0 0 18 18" fill="currentColor"><rect x="4" y="2.5" width="2.4" height="13" rx="1.2"/><rect x="11.6" y="2.5" width="2.4" height="13" rx="1.2"/></svg>'

export function initTtsPlayer() {
  document.querySelectorAll('.lgc-tts-player').forEach(el => {
    const wrap = el.closest('.lgc-tts-player-wrap')
    if (!wrap) return
    if (wrap.dataset.ttsInit) return
    wrap.dataset.ttsInit = '1'
    const listenLabel = wrap.dataset.listenLabel || 'Listen'
    const minLabel = wrap.dataset.minLabel || 'minutes'
    const minLabelSingular = wrap.dataset.minLabelSingular || minLabel

    const player = new Plyr(el, {
      controls: ['play', 'current-time', 'progress', 'duration', 'rewind', 'fast-forward'],
      seekTime: 10,
    })

    const showSubscribeBanner = () => {
      new EvolokBannerManager({}).showBanner(window.userType, 'tts')
    }

    // The DOM src is the stable endpoint (admin-ajax): the browser resolves it
    // via 302 into a Tigris presigned URL, which expires. If a media request
    // fails (e.g. play/seek after hours on the page), reload the source from
    // the endpoint - fresh 302, fresh signature - and resume where it was.
    // A 403 from the endpoint itself (not subscribed, or a stale/spoofed
    // window.userType that let the optimistic gate below through) is a
    // permanent rejection, not a transient one: show the banner, don't retry.
    let lastRecovery = 0
    const recoverSource = () => {
      const now = Date.now()
      if (now - lastRecovery < 5000) return // no retry loop on repeated errors
      lastRecovery = now

      const src = el.currentSrc || el.src
      fetch(src, { headers: { Range: 'bytes=0-1' } })
        .then((res) => {
          if (res.status === 403) {
            showSubscribeBanner()
            return
          }

          const time = el.currentTime
          const wasPlaying = !el.paused && !el.ended

          el.addEventListener('loadedmetadata', () => {
            if (Number.isFinite(time) && time > 0) el.currentTime = time
            if (wasPlaying) el.play().catch(() => { })
          }, { once: true })

          el.load()
        })
        .catch(() => {
          // Network unreachable
        })
    }

    el.addEventListener('error', recoverSource)
    const sourceEl = el.querySelector('source')
    if (sourceEl) sourceEl.addEventListener('error', recoverSource)

    const setDuration = () => {
      if (!Number.isFinite(player.duration) || player.duration <= 0) return
      const durationEl = wrap.querySelector('.lgc-tts-label-duration')
      if (!durationEl) return
      const mins = Math.ceil(player.duration / 60)
      const label = mins === 1 ? minLabelSingular : minLabel
      durationEl.textContent = ` ${mins} ${label}`
    }

    player.on('ready', () => {
      const playBtn = wrap.querySelector('[data-plyr="play"]')
      if (!playBtn) return

      // Optimistic client-side gate, mirrors _handlePdfButton/_handleSaveButton:
      // window.userType is set synchronously in theme/header.php before any
      // module script runs. Capture phase so this runs before Plyr's own
      // click handler (bubble phase) starts playback. The real gate is
      // server-side (serve_audio() 403), handled in recoverSource() above.
      playBtn.addEventListener('click', (e) => {
        if (window.userType === 'subscribed') return
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        showSubscribeBanner()
      }, true)

      const pauseSvg = playBtn.querySelector('.icon--pressed')
      if (pauseSvg) pauseSvg.outerHTML = PAUSE_ICON
      const label = document.createElement('span')
      label.className = 'lgc-tts-label'
      label.innerHTML = `<span class="lgc-tts-label-text">${listenLabel}</span><span class="lgc-tts-label-duration"></span>`
      playBtn.after(label)
      setDuration()

      const rewindSvg = wrap.querySelector('[data-plyr="rewind"] svg')
      if (rewindSvg) rewindSvg.outerHTML = REWIND_ICON
      const forwardSvg = wrap.querySelector('[data-plyr="fast-forward"] svg')
      if (forwardSvg) forwardSvg.outerHTML = REWIND_ICON

      const seekInput = wrap.querySelector('input[data-plyr="seek"]')
      if (seekInput) {
        player.on('timeupdate', () => {
          if (!player.duration) return
          const pct = (player.currentTime / player.duration) * 100
          seekInput.style.setProperty('--value', `${pct}%`)
        })
      }
    })

    player.on('loadedmetadata', setDuration)

    player.on('play', () => wrap.classList.add('is-active'))
  })
}
